import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import HaulingImg1 from '../../assest/Hauling-1.png';
import HaulingImg2 from '../../assest/Trailer-2.png';
import HaulingImg3 from '../../assest/Container.png';

const haulingList = [
  {
    name: "Flatbed Hauling",
    image: HaulingImg1,
    specs: "Transport of oversized or heavy machinery.",
    description: "Ideal for hauling large equipment like generators, loaders, or steel beams.",
  },
  {
    name: "Lowboy Trailer Service",
    image: HaulingImg2,
    specs: "Heavy-duty transport for tall or bulky items.",
    description: "Used for moving construction vehicles or equipment with high clearance needs.",
  },
  {
    name: "Container Transport",
    image: HaulingImg3,
    specs: "Secure hauling of material storage containers.",
    description: "Reliable service for moving loaded or empty site containers efficiently.",
  },
];

const translations = {
  gb: {
    heading: "Equipment Hauling Services",
    introText: "Dependable hauling solutions for your heavy and oversized equipment.",
    categoriesTitle: "Available Hauling Options",
    featuredTitle: "Top Hauling Methods",
    featuredDescription: "Choose from our specialized transport options designed for equipment safety and efficiency.",
  },
  sa: {
    heading: "خدمات سحب المعدات",
    introText: "حلول موثوقة لسحب المعدات الثقيلة والكبيرة الحجم.",
    categoriesTitle: "خيارات السحب المتاحة",
    featuredTitle: "أفضل طرق السحب",
    featuredDescription: "اختر من بين خيارات النقل المتخصصة المصممة لأمان وكفاءة المعدات.",
  },
};

const EquipmentHauling = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={haulingList}
      language={language}
    />
  );
};

export default EquipmentHauling;
